import React, { Component } from 'react';
import ArrowKeysReact from 'arrow-keys-react';

class ArrowControllerBase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: 'Use arrow keys on your keyboard!'
    };

    ArrowKeysReact.config({
      left: () => this.handleDirection('left'),
      right: () => this.handleDirection('right'),
      up: () => this.handleDirection('up'),
      down: () => this.handleDirection('down')
    });
  }

  handleDirection = (direction) => {
    this.setState({
      content: `${direction} key detected.`
    });
  }

  setUp = () => this.handleDirection('up');
  setDown = () => this.handleDirection('down');
  setLeft = () => this.handleDirection('left');
  setRight = () => this.handleDirection('right');

  render() {
    const { children, showButtons = true } = this.props;
    
    return (
      <div {...ArrowKeysReact.events} tabIndex="1">
        {this.state.content}
        <br/>
        {showButtons && (
          <>
            <button onClick={this.setUp}> up </button>
            <button onClick={this.setDown}> down </button>
            <button onClick={this.setLeft}> left </button>
            <button onClick={this.setRight}> right </button>
          </>
        )}
        {children && children(this.state.content)}
      </div>
    );
  }
}

export default ArrowControllerBase;
